import React, { Fragment, Suspense } from "react";
import './css/style.css';
import AppRoutes from "./AppRoutes";
const BrowserRouter = require("react-router-dom").BrowserRouter;
function App() {
  return (
      <BrowserRouter>
      {/* <Suspense fallback={<div>Loading...</div>}> */}
        <AppRoutes />
        {/* </Suspense> */}
      </BrowserRouter>
  );
}

export default App;
